import Information16 from '@carbon/icons-react/es/information/16';
import styled from 'styled-components';
import { ProjectHours } from 'api/project';
import { Label01, BodyShort01 } from 'ozone/atoms';

export interface Props {
  projectHours: ProjectHours;
}

export const Percentage = styled(Label01)`
  margin-left: var(--spacing-02);
  color: var(--gray-50);

  &::before {
    content: '(';
  }

  &::after {
    content: '%)';
  }
`;

export const Row = styled.div`
  display: flex;
  margin-top: var(--spacing-05);
`;

export const Half = styled.div`
  flex: 0 0 50%;
`;

export const Line = styled.div`
  width: 256px;
  display: flex;
  color: var(--gray-50);
  margin-top: var(--spacing-03);
  margin-bottom: var(--spacing-02);

  ${BodyShort01} {
    color: var(--gray-50);
  }
`;

export const Icon = styled(Information16)`
  flex: 0 0 auto;
  margin-right: var(--spacing-02);
  margin-top: 2px;
`;
